module.exports = __webpack_public_path__ + "img/logo.6a2bf44c.svg";